const initButtonLinkByIds = function (linkId, tabId) {
  document.addEventListener('DOMContentLoaded', function () {
    const link = document.getElementById(linkId);
    const tab = document.getElementById(tabId);

    if (link && tab) {
      const bootstrapTab = bootstrap.Tab.getOrCreateInstance(tab);
      link.addEventListener('click', function (e) {
        bootstrapTab.show();
      });
    }
  });
};
